import { MRT_ColumnDef, MRT_PaginationState } from "material-react-table";
import { useState } from "react";
import { Box, Button, Chip, IconButton, Typography } from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { DataTable } from "../../libs/core/components/data-table";
import { ConfirmModal } from "../../libs/ui/modal/confirm_modal";
import { UnitType } from "./types/unitType";
import { useDeleteUnitTypeMutation, useGetUnitTypesQuery } from "./api/unitTypesApi";
import AddEditUnitType from "./components/AddEditUnitType";

const UnitTypeManager: React.FC = () => {
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });

  const [openDialog, setOpenDialog] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [selectedUnitType, setSelectedUnitType] = useState<UnitType | null>(null);
  const navigate = useNavigate();

  const { data: unitTypes, isLoading, isError, isFetching } = useGetUnitTypesQuery();
  const [deleteUnitType] = useDeleteUnitTypeMutation();

  const columns: Array<MRT_ColumnDef<UnitType>> = [
    {
      header: "Name",
      accessorKey: "name",
    },
  ];

  return (
    <Box>
      <DataTable<UnitType>
        toolbar={
          <Box display="flex" alignItems="center" width="100%">
            <Box display="flex" gap={3} alignItems="center" flex="1">
              <Typography variant="h6">Unit Types</Typography>
              <Chip
                color="primary"
                variant="outlined"
                label={`${unitTypes?.data?.length ?? 0} Unit Types`}
              />
            </Box>
            <Button
              onClick={() => {
                setSelectedUnitType(null);
                setOpenDialog(true);
              }}
              sx={{ minWidth: "200px" }}
              variant="contained"
            >
              Add New Unit Type
            </Button>
          </Box>
        }
        list={unitTypes?.data ?? []}
        count={unitTypes?.data?.length ?? 0}
        columns={columns}
        getRowId={(row) => row.id?.toString()}
        isLoading={isLoading}
        isSuccess={!isError}
        isError={isError}
        isFetching={isFetching}
        renderRowActions={(row) => (
          <Box display={"flex"} gap={1}>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                setSelectedUnitType(row);
                setOpenConfirmModal(true);
              }}
            >
              <Delete />
            </IconButton>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                setSelectedUnitType(row);
                setOpenDialog(true);
              }}
            >
              <Edit />
            </IconButton>
          </Box>
        )}
        pagination={pagination}
        onPaginationChange={setPagination}
        rowNumberMode={undefined}
      />

      <AddEditUnitType
        open={openDialog}
        unitType={selectedUnitType}
        setOpen={setOpenDialog}
      />

      {selectedUnitType && (
        <ConfirmModal
          type="warning"
          title="Delete Unit Type"
          message={`Are you sure you want to delete the unit type '${selectedUnitType.name}'?`}
          modalOpen={openConfirmModal}
          setModalOpen={setOpenConfirmModal}
          onOk={() => {
            deleteUnitType(selectedUnitType.id.toString());
            setOpenConfirmModal(false);
            setSelectedUnitType(null);
          }}
        />
      )}
    </Box>
  );
};

export default UnitTypeManager;
